
<form @submit.prevent="post()" class="ui form signupForm" :class="{'warning': form.hasErrors()}">
  <div class="ui two column middle very relaxed stackable grid">
    <div class="center aligned column loginForm__column">
      <h2 class="signupForm__sectionTitle">メールアドレスで登録</h2>
      <app-message :msg="form.appMessage"></app-message>
      <div class="ui form">
        <div class="field">
          <div class="ui left icon input">
            <input v-model="form.model.login_id" type="text" placeholder="メールアドレス" />
            <i class="user icon"></i>
          </div>
          <validation-message :form="form" :field="'login_id'"></validation-message>
        </div>
        <div class="field">
          <div class="ui left icon input">
            <i class="lock icon"></i>
            <input v-model="form.model.password" type="password" placeholder="パスワード">
          </div>
          <validation-message :form="form" :field="'password'"></validation-message>
        </div>
        <div class="field">
          <checkbox v-model="form.model.iAgree">
            <a href="/term" target="_blank">利用規約</a>に同意
          </checkbox>
        </div>
        <div class="field">
          <button type="submit" class="ui fluid orange submit button" :class="{'loading disabled': form.waiting, 'disabled': !form.model.iAgree}">会員登録</button>
        </div>
      </div>
    </div>
    <!-- semantic ui bug https://github.com/Semantic-Org/Semantic-UI/issues/4342#issuecomment-326776812 -->
    <div style="position:relative; margin:0; padding:0;">
      <div class="ui vertical divider signupForm__sectionDivider">
        または
      </div>
    </div>
    <div class="center aligned column signupForm__column">
      <h2 class="loginForm__sectionTitle">SNSアカウントで登録</h2>
      <div v-if="socialAuthErrorCode" class="ui negative message">
        <span v-if="socialAuthErrorCode === 'oauth'">
        SNSとの連携に失敗しました。
        </span>
      </div>
      <div class="ui form">
        <div class="field">
          <button type="button" class="ui fluid large facebook button" :class="{'loading disabled': facebookLoading}" @click="facebook()">
            <i class="facebook f icon"></i>Facebookで登録する
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
